import { StreamEvent } from '../../models/assistant';

const CHUNK_SIZE = 4;

interface Latency {
  /** Between two small pieces of the answer. */
  textDelayMs?: number;
}

const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * Makes the text of a stream arrive in small pieces, as it does from a real model on a slow
 * connection. A whole answer can arrive in a few milliseconds, which hides how the screen grows.
 */
export default async function* withSimulatedLatency(
  events: AsyncIterable<StreamEvent>,
  { textDelayMs = 30 }: Latency = {}
): AsyncGenerator<StreamEvent> {
  for await (const event of events) {
    if (event.type === 'delta') {
      for (let start = 0; start < event.text.length; start += CHUNK_SIZE) {
        await sleep(textDelayMs);
        yield {
          type: 'delta',
          text: event.text.slice(start, start + CHUNK_SIZE),
        };
      }
    } else {
      yield event;
    }
  }
}
